import { create } from "zustand";

export const useAccountRegisterStore = create((set) => ({
  idCard: null,
  dob: null,
  isForeigner: false,
  phoneNumber: null,
  isOtpVerified: false,
  setIdCard: (idCard) => set({ idCard }),
  setDob: (dob) => set({ dob }),
  setIsForeigner: (isForeigner) => set({ isForeigner }),
  setPhoneNumber: (phoneNumber) => set({ phoneNumber }),
  setIsOtpVerified: (isOtpVerified) => set({ isOtpVerified }),
}));
